document.addEventListener('DOMContentLoaded', function() {
  var swiper = new Swiper(".seen-on-logos", {
      slidesPerView: 6,
      grabCursor: true,
      loop: true,
        breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 3,
          spaceBetween: 20
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 4,
          spaceBetween: 30
        },
        // when window width is >= 640px
        640: {
          slidesPerView: 6,
          spaceBetween: 40
        }
    }
  });
})